import React from "react";
import FibreProsSection from "@/bit/components/components.fibre-pros-section";
import ExpandableTextList from "@/component/expandable-text-list";
import ServiceCard from "@/component/service-card";
import LocationText from "@/component/location-text";
import FaqsCompo from "@/component/faqs";
import InterestCard from "@/component/interest-card";
import RecomCharacteristics from "@/component/recom-characteristics";
import Card from "@/component/card";
import Teletipo from "@/component/teletipo"

const filePath = "layout/fichas.js";

/**
 * @name Layout
 * @description Connectivity page layout
 * @param {any} props
 * @returns {React.FC}
 */

export default function Layout(props) {
  return (
    <main>
      {props["MODULO_TELETIPO"] && (
        <>
          <Teletipo
            orionInfo={props["MODULO_TELETIPO"]}
            productName={props?.productName}
          />
        </>
      )
      }
      {
        props["MODULO_CARDS"] && (
          <ServiceCard
            orionInfo={props["MODULO_CARDS"]}
            productName={props?.productName}
          />
        )
      }
      {
        props["MODULO_CARDS"] && (
          <LocationText
            orionInfo={props["MODULO_CARDS"]}
            productName={props?.productName}
          />
        )
      }
      {
        props["LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION"] &&
        props["LISTADO_PASOS_ICONO_TITULO_DESCRIPCION"] && (
          <FibreProsSection
            sectionLeft={
              props["LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION"]
            }
            sectionRight={props["LISTADO_PASOS_ICONO_TITULO_DESCRIPCION"]}
            simplePhone={props["MODULO_SIMPLEPHONE"]}
          />
        )
      }
      {
        props["MODULO_RECOMENDACION"] && (
          <RecomCharacteristics {...props["MODULO_RECOMENDACION"]} />
        )
      }
      {
        props["FAQS_PREGUNTAS_FRECUENTES"] && (
          <FaqsCompo {...props["FAQS_PREGUNTAS_FRECUENTES"]} />
        )
      }
      {
        props["FAQS_EXPANDIDAS"] && (
          <ExpandableTextList {...props["FAQS_EXPANDIDAS"]} />
        )
      }
      {
        props["MODULO_VENTA_CRUZADA"] && (
          <InterestCard {...props["MODULO_VENTA_CRUZADA"]} />
        )
      }
    </main >
  );
}
